<!--
 * @Author: guoyu
 * @Date: 2020-06-15 19:23:46
 * @LastEditors: your name
 * @LastEditTime: 2020-06-15 20:41:47
 * @Description: 将组件挂到指定位置
-->
<template>
  <div ref="amountContent">
    <slot></slot>
  </div>
</template>
<script>
export default {
  model: {
    event: 'change',
    prop: 'val'
  },
  props: {
    amountEl: {
      default: () => {
        return document.body;
      }
    },
    val: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    val(newVal) {
      if (newVal) {
        this.open();
      }
    },
    amountEl() {
      this.open();
    }
  },
  methods: {
    open() {
      this.$nextTick(() => {
        this.amountEl.appendChild(this.$el);
      });
    }
  },
  mounted() {
    if (!this.val) return;
    this.open();
  }
};
</script>
